var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"projects page"},[_c('KkCardProjects',{attrs:{"pageIndicator":_vm.indicator,"textBlocks":_vm.tempTexts,"title":_vm.projectTitle,"logo":_vm.logo,"blockImg":_vm.img}}),_c('ContactBanner'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }